import type { AssetDetail } from "@/hooks/useAssetDetail";

export type AssetSpecRow = { label: string; value: string };

function formatBytes(bytes: number | null): string {
  if (bytes == null || bytes <= 0) return "—";
  const units = ["B", "KB", "MB", "GB"];
  let size = bytes;
  let i = 0;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }
  return `${size.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

/** Rows for the asset detail spec table (poly/tris reserved for future API fields). */
export function buildAssetSpecRows(asset: AssetDetail): AssetSpecRow[] {
  const formatGuess =
    asset.tags?.find((t) => /\.(fbx|glb|uasset|png|wav|verse)$/i.test(t)) ?? null;
  const tagLine =
    asset.tags?.length ? asset.tags.join(", ") : "—";
  const categoryLine = asset.category?.name ?? "—";

  return [
    { label: "Category", value: categoryLine },
    { label: "Tags", value: tagLine },
    { label: "Polycount", value: "—" },
    { label: "Triangles", value: "—" },
    { label: "Primary format", value: formatGuess ?? "See package / description" },
    { label: "Engine", value: "UEFN / Fortnite Creative" },
    { label: "Package size", value: formatBytes(asset.file_size) },
    { label: "Version", value: asset.version?.trim() || "—" },
    { label: "Last updated", value: asset.updated_at ? new Date(asset.updated_at).toISOString().slice(0, 10) : "—" },
  ];
}
